import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/*if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.info('SW registered: ', registration);
    }).catch(registrationError => {
      console.info('SW registration failed: ', registrationError);
    });
  });
}*/

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));